import { Tag } from '../../state/types'

/**
 * Extract tags that are actually referenced in the text
 */
export function extractTagsFromText(text: string, availableTags: Tag[]): Tag[] {
  return availableTags.filter(tag => 
    text.includes(`@${tag.target_username}`)
  )
}

/**
 * Remove tags that are no longer in the text
 */
export function pruneTags(currentTags: Tag[], text: string): Tag[] {
  return currentTags.filter(tag => 
    text.includes(`@${tag.target_username}`)
  )
}

/**
 * Check if two tag arrays are equal
 */
export function areTagsEqual(tags1: Tag[], tags2: Tag[]): boolean {
  if (tags1.length !== tags2.length) return false
  
  const ids1 = new Set(tags1.map(t => t.id))
  const ids2 = new Set(tags2.map(t => t.id))
  
  return ids1.size === ids2.size && [...ids1].every(id => ids2.has(id))
}

/**
 * Build metadata object for chat request
 */
export function buildChatMetadata(tags: Tag[]): { tags: Tag[] } | undefined {
  return tags.length > 0 ? { tags } : undefined
} 